import { api } from '../../lib/api.ts';

export type WapsignRole = 'USER' | 'ORG_ADMIN';
export type WapmeetRole =
  | 'PRESIDENT'
  | 'VICE_PRESIDENT'
  | 'SECRETARY_GENERAL'
  | 'MEMBER'
  | 'BUREAU_STAFF'
  | 'VIEWER'
  | 'WDC_PRESIDENT'
  | 'WDC_VICE_PRESIDENT'
  | 'WDC_MEMBER';
export type WapstatRole = 'ADMIN' | 'ENUMERATOR';
export type WapstatZoneRole = 'COUNCILLOR' | 'SECRETARY_GENERAL' | 'STAFF';
export type WapproRole = 'ADMIN' | 'STAFF' | 'STOCKKEEPER' | 'FINANCE';
export type WapdocsRole = 'USER' | 'ORG_ADMIN';

// Per-app provisioning requested at invite time. Each app account is created on
// accept with the same password the invitee chooses for Office.
export interface AppProvisioning {
  wapsign?: { role: WapsignRole };
  wapmeet?: { role: WapmeetRole; isOrgAdmin: boolean };
  wapstat?: { role: WapstatRole | null; zoneRole: WapstatZoneRole | null; isOrgAdmin: boolean };
  wappro?: { role: WapproRole };
  wapdocs?: { role: WapdocsRole };
}

export interface InviteRow {
  id: string;
  email: string;
  isOrgAdmin: boolean;
  expiresAt: string;
  createdAt: string;
  appProvisioning?: AppProvisioning | null;
}

export interface CreatedInvite {
  invite: {
    id: string;
    email: string;
    isOrgAdmin: boolean;
    expiresAt: string;
    appProvisioning?: AppProvisioning | null;
  };
}

export const invitesApi = {
  list: () => api.get<{ invites: InviteRow[] }>('/invites').then((r) => r.data.invites),
  create: (email: string, isOrgAdmin: boolean, appProvisioning?: AppProvisioning) =>
    api.post<CreatedInvite>('/invites', { email, isOrgAdmin, appProvisioning }).then((r) => r.data),
};
